/**
 * Includes all visible fileupload states, other ones should never reach the FE
 */
export enum FileUploadState {
  ANALYZER_ERROR = 'analyzer_error',
  ANALYZING = 'analyzing',
  ANALYZED = 'analyzed',
  BATCH_TRANSCRIBE = 'batch_transcribe',
  COMPLETE = 'complete',
  PROCESSED = 'processed',
  READY = 'ready',
  REANALYZE = 'reanalyze',
  RETRANSCRIBE = 'retranscribe',
  TRANSCRIBED = 'transcribed',
  TRANSCRIBING = 'transcribing',
  TRANSCRIPTION_ERROR = 'transcription_error',
  SUMMARIZING = 'summarizing',
  SUMMARIZER_ERROR = 'summarizer_error',
  TRANSCRIPTION_TIMEOUT = 'transcription_timeout',
  METADATA_ONLY = 'metadata_only',
}

export const CONVERTING_STATES: Array<FileUploadState | string> = [
  FileUploadState.PROCESSED,
  FileUploadState.READY,
];

export const TRANSCRIBING_STATES: Array<FileUploadState | string> = [
  FileUploadState.BATCH_TRANSCRIBE,
  FileUploadState.TRANSCRIBING,
  FileUploadState.TRANSCRIBED,
  FileUploadState.RETRANSCRIBE,
];

export const ANALYZING_STATES: Array<FileUploadState | string> = [
  FileUploadState.SUMMARIZING,
  FileUploadState.ANALYZING,
  FileUploadState.ANALYZED,
  FileUploadState.REANALYZE,
];

export const COMPLETE_STATES: Array<FileUploadState | string> = [FileUploadState.COMPLETE];

export const ERROR_STATES: Array<FileUploadState | string> = [
  FileUploadState.TRANSCRIPTION_TIMEOUT,
  FileUploadState.TRANSCRIPTION_ERROR,
  FileUploadState.ANALYZER_ERROR,
  FileUploadState.SUMMARIZER_ERROR,
];

export const inPreTranscribedState = (state: FileUploadState) => {
  const lowerCaseState = state.toLowerCase();
  return CONVERTING_STATES.includes(lowerCaseState) || TRANSCRIBING_STATES.includes(lowerCaseState);
};

export const inErrorState = (state: FileUploadState) => {
  return ERROR_STATES.includes(state.toLowerCase());
};
